export const fmt = money => (money && money.formatted) || "—"

export const fmtWhole = money => {
  if (!money || money.cents == null) return "—"
  const value = (money.cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 })
  return `${value} ${money.symbol || "€"}`
}

export const pct = value => {
  if (value == null || isNaN(value)) return "—"
  const n = Math.round(Number(value))
  return `${n} %`
}

export const initials = name =>
  String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase())
    .join("")

export const dateFmt = value => {
  if (!value) return "—"
  const d = new Date(value)
  if (isNaN(d.getTime())) return value
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" })
}

export const STATUS_STYLES = {
  not_started: "bg-slate-100 text-slate-700 ring-slate-200",
  in_progress: "bg-blue-50 text-blue-700 ring-blue-200",
  blocked:     "bg-rose-50 text-rose-700 ring-rose-200",
  completed:   "bg-emerald-50 text-emerald-700 ring-emerald-200",
  draft:       "bg-slate-100 text-slate-700 ring-slate-200",
  active:      "bg-emerald-50 text-emerald-700 ring-emerald-200",
  on_hold:     "bg-amber-50 text-amber-700 ring-amber-200",
  reception:   "bg-indigo-50 text-indigo-700 ring-indigo-200",
  cancelled:   "bg-slate-100 text-slate-500 ring-slate-200",
  paid:        "bg-emerald-50 text-emerald-700 ring-emerald-200",
  pending:     "bg-amber-50 text-amber-700 ring-amber-200",
  sent:        "bg-blue-50 text-blue-700 ring-blue-200",
  accepted:    "bg-emerald-50 text-emerald-700 ring-emerald-200",
  rejected:    "bg-rose-50 text-rose-700 ring-rose-200",
}

export const statusClass = status =>
  STATUS_STYLES[status] || "bg-slate-100 text-slate-700 ring-slate-200"

export const AVATAR_COLORS = [
  "bg-emerald-600", "bg-blue-600", "bg-amber-600", "bg-rose-600",
  "bg-violet-600", "bg-cyan-600", "bg-orange-600", "bg-pink-600",
]

export const colorFor = name => {
  let hash = 0
  for (const c of String(name || "")) hash = (hash * 31 + c.charCodeAt(0)) >>> 0
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}

export const fmtHours = hours => {
  const rounded = Math.round((Number(hours) || 0) * 100) / 100
  return `${String(rounded).replace(".", ",")} ${I18n.t("projects.units.hour_short")}`
}

export const fmtHoursDays = (hours, hoursPerDay) => {
  const value = Number(hours) || 0
  const per   = Number(hoursPerDay) || 7
  const days  = Math.round((value / per) * 10) / 10
  return `${fmtHours(value)} · ${String(days).replace(".", ",")} ${I18n.t("projects.units.day_short")}`
}
